import React from 'react';
import Header from './layout/Header';
import Footer from './layout/Footer';
import Nav from './layout/Nav';
import Pin from './layout/Pin';
import withCheckUser from './auth/withCheckUser';

function App(props) {
    const { children, update } = props;
    const { invId } = sessionStorage;
    // const hash = location.hash.substr(1);
    const hash = location.hash.substr(1).split('?')[0];
    return (
        <div>
            <Header hash={hash} />
            {
                (hash !== '/executeMgr/visitPeriodPlanHandle' && hash !== '/clinicalEvaluation/ViewPage' && hash !== '/clinicalEvaluation/DockingData') && //bug 33619，审批不需要显示Nav; 访视评估参考报价不需要显示Nav; 查看访视评估对接信息不需要显示Nav
                <Nav hash={hash} update={update} />
            }
            { ((invId > 0)||(hash==="/financeManagement/financeIncomeReport")) && <Pin /> }
            {/* 财务收入报告展示重跑 */}
            {
                hash === '/home' ?
                    children
                :
                    <div className="container">
                        <div className="wrapper">
                            {
                                React.Children.map(children, (element) => {
                                    return React.cloneElement(element, { update });
                                })
                            }
                        </div>
                    </div>
            }
            <Footer />
        </div>
    );
}

export default withCheckUser(App);


// WEBPACK FOOTER //
// ./src/components/App.js